module.exports = __webpack_public_path__ + "static/media/lefthand.59789903.png";